<template>
  <div>
    <div class="content">
      <div class="content-main">
        <p class="content-title">商品库存<un-lock/><page-desc/></p>
        <div class="content-input">
          <div class="content-input-left">
            <div class="content-input-item">
              <label>所属门店</label>
              <el-select v-model="shopId" placeholder="Select" class="select-item">
                <el-option v-for="item in shopIdArray" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <label>商品分类</label>
              <el-select v-model="typeId" placeholder="Select" class="select-item" style="margin-right: 8px;" @change="typeChange" filterable>
                <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
              <el-select v-model="subTypeId" placeholder="Select" class="select-item" filterable>
                <el-option v-for="item in subTypeList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <label>库存状态</label>
              <el-select v-model="stockWarnState" placeholder="Select" class="select-item">
                <el-option v-for="item in stockWarnStateArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>

            <div class="content-input-item">
              <label>供应商</label>
              <el-select v-model="supplierId" placeholder="Select" class="select-item" filterable>
                <el-option v-for="item in supplierIdArray" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <label>品牌</label>
              <el-select v-model="brandId" placeholder="Select" class="select-item" filterable>
                <el-option v-for="item in brandIdArray" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>

            <div class="content-input-item">
              <label>商品名称</label>
              <SearchComponents :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" width="7em"/>
              <el-checkbox v-model="limitState" style="margin-left: 8px;"><span style="white-space: nowrap; flex-shrink: 0">有限制</span></el-checkbox>
            </div>



          </div>
          <div class="content-input-right">
            <div class="content-input-btn">
              <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
            </div>
            <div class="content-input-btn">
              <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
            </div>
          </div>

        </div>
      </div>
      <div class="content-main">
        <!--        <p class="content-title" style="padding-bottom: 16px;">用户权限</p>-->
        <div class="content-button">
          <div>
<!--            <el-button type="primary" @click="editCommodityDialog(-1)" size="default">添加</el-button>-->
          </div>
          <BtnGroup :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
        </div>
        <div class="content-table">
          <el-table
              ref="multipleTableRef"
              :data="pageDataList"
              style="width: 100%; "
              v-loading="listLoading"
              @cell-click="toggleSelection"
              size="default"
              border
              @sort-change="sortChange"
          >
            <!--            <el-table-column property="id" label="ID" v-if="checkColList.indexOf('ID') > -1"/>-->
            <el-table-column property="shopName" label="所属门店" v-if="checkColList.indexOf('所属门店') > -1"/>
            <el-table-column property="supplierName" label="供应商" v-if="checkColList.indexOf('供应商') > -1"/>
            <el-table-column property="brandName" label="品牌" v-if="checkColList.indexOf('品牌') > -1"/>
            <el-table-column property="commodityName" label="商品名称" v-if="checkColList.indexOf('商品名称') > -1"/>
            <el-table-column property="" label="商品图片" v-if="checkColList.indexOf('商品图片') > -1">
              <template #default="scope">
                <div v-if="scope.row.commodityImgList.length > 0" class="cursor" @click="userImgList(scope.row)">
                  <el-image class="item-img" fit="cover" :src="scope.row.commodityImgList[0].smallImg"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
                </div>
                <div v-else>
                  <el-image class="item-img" fit="cover"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
                </div>
              </template>
            </el-table-column>
            <el-table-column property="commodityTypeName" label="商品分类" v-if="checkColList.indexOf('商品分类') > -1">
              <template #default="scope">
                {{scope.row.commodityTypePreName?scope.row.commodityTypePreName + '/':''}}{{scope.row.commodityTypeName}}
              </template>
            </el-table-column>
            <el-table-column property="specification" label="商品规格" v-if="checkColList.indexOf('商品规格') > -1"/>
            <el-table-column property="measureUnitName" label="计量单位" v-if="checkColList.indexOf('计量单位') > -1"/>
            <el-table-column property="price" label="进货单价" v-if="checkColList.indexOf('进货单价') > -1"/>
            <el-table-column property="retailPrice" label="建议零售价" v-if="checkColList.indexOf('建议零售价') > -1"/>
            <el-table-column property="shopRetailPrice" label="门店零售价" v-if="checkColList.indexOf('门店零售价') > -1"/>
            <el-table-column property="stockNum" label="库存量" v-if="checkColList.indexOf('库存量') > -1" sortable='custom'/>
            <el-table-column property="" label="库存状态" v-if="checkColList.indexOf('库存状态') > -1">
              <template #default="scope">
                <p :style="{color: scope.row.stockWarnState == 1?'red':''}">{{scope.row.stockWarnState == 0?'正常':scope.row.stockWarnState == 1?'预警':'' }}</p>
              </template>
            </el-table-column>
            <el-table-column label="操作" v-if="checkColList.indexOf('操作') > -1">
              <template #default="scope">
                <el-space wrap>
                  <el-button @click="commodityStockListDialog(scope.$index,scope.row)" size="small" type="primary">详情</el-button>
                </el-space>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { getFormData, postFormData } from "@/api/api";
import {getShopCommodityPageList, listAllBrand, listAllSupplier, updateCommodityState, listAllCommodityType} from "@/api/url";
// import CommodityDialog from "./components/CommodityDialog";
import Dialog from "@/assets/js/dialog"
import BtnGroup from '../../components/BtnGroup'
import SearchComponents from "@/components/SearchComponents";
import Drawer from "@/assets/js/drawer";
import UserImgList from "@/components/imgList/UserImgList";
import DatePickerRange from "@/components/DatePickerRange";
import StockRemarkDialog from "@/views/stock/components/StockRemarkDialog";
import StockListDialog from "@/views/stock/components/StockListDialog";
import CommodityStockDialog from "@/views/stock/components/CommodityStockDialog";
import unLock from "@/layout/components/unLock";

export default {
  name: "StockCommodity",
  components: { BtnGroup, SearchComponents,DatePickerRange, unLock },
  data() {
    return {
      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      limitState: false,

      shopIdArray: [],
      shopIdArr:[],
      shopId: 0,

      //时间
      startTime: '',
      endTime: '',
      isChecked: false,

      stockWarnStateArray: [
        {label: '不限', value: -1},
        {label: '正常', value: 0},
        {label: '预警', value: 1},
      ],
      stockWarnState: -1,

      supplierIdArray: [],
      supplierId: 0,

      brandIdArray: [],
      brandId: 0,

      typeList: [
        {name: '不限', id: 0}
      ],
      typeId: 0,
      subTypeList: [
        {name: '不限', id: 0}
      ],
      subTypeId: 0,


      //刷新组
      colList: ['所属门店', '供应商', '品牌', '商品名称', '商品图片', '商品分类','商品规格', '计量单位', '进货单价', '建议零售价', '门店零售价', '库存量', '库存状态', '操作'],
      checkColList: [],

      //搜索
      searchTypeList: [
        {label : '商品名称', value : 1},
      ],
      searchType: 1,
      searchValue: '',

      sort: 0,

    }
  },
  methods: {
    // 重置参数
    refreshParam() {
      this.isChecked = false;
      this.stockWarnState = -1;
      this.limitState = false;
      this.sort = 0;
      this.typeId = 0;
      this.subTypeId = 0;
      this.brandId = 0;
      this.supplierId = 0;
      this.searchValue = '';
      this.searchType = 1;
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    typeChange() {
      this.subTypeId = 0
      this.subTypeList = [
        {name: '不限', id: 0}
      ]
      if(this.typeId != 0) {
        for(let i=0; i<this.typeList.length; i++) {
          if(this.typeId == this.typeList[i].id) {
            this.subTypeList = this.subTypeList.concat(this.typeList[i].subTypeList)
          }
        }
      }
    },

    //排序
    sortChange(column) {
      if(column.prop == 'stockNum') {
        if(column.order == 'descending') {
          this.sort = 1;
        } else if(column.order == 'ascending') {
          this.sort = 2;
        }
      }
      this.getPage();
    },


    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['stockWarnState'] = this.stockWarnState;
      param['limitState'] = this.limitState?1:0;
      // param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      param['commodityTypePreId'] = this.typeId;
      param['commodityTypeId'] = this.subTypeId;
      param['supplierId'] = this.supplierId;
      param['brandId'] = this.brandId;
      param['shopId'] = this.shopId;
      param['sort'] = this.sort;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getShopCommodityPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },


    commodityStockListDialog(idx, row) {
      let _title = '单品库存详情';
      let stockForm = Object.assign({}, row);
      stockForm.shopCommodityId = stockForm.id
      stockForm.currentStockNum = stockForm.stockNum
      Dialog.open({
        title: _title,
        component: CommodityStockDialog,
        data: {
          stockForm: stockForm,
          // showBtn: true,
          width: '1200px',
          showInfo: true,
        },
        close: (result) => {
          this.getPage()
        }
      })
    },

    //
    // updateState(row, state) {
    //   row.updateLoading = true;
    //   let param = {};
    //   param['id'] = row.id;
    //   param['state'] = state;
    //   postFormData(updateCommodityState, param).then((data)=>{
    //     let {code, msg} = data;
    //     if (code == 200) {
    //       this.$message({
    //         showClose: true,
    //         duration: 1000,
    //         message: msg,
    //         type: 'success'
    //       })
    //       row.state = state
    //     }else {
    //       this.$message({
    //         showClose: true,
    //         duration: 1000,
    //         message: msg,
    //         type: 'warning'
    //       })
    //     }
    //     row.updateLoading = false;
    //   }).catch(()=> {
    //     row.updateLoading = false;
    //   })
    // },

    userImgList(row) {
      let _title = '';
      _title = '图片列表'
      Drawer.open({
        title: _title,
        component: UserImgList,
        data: {
          imgArray: row.commodityImgList,
          id: row.id,
          width: 908,
          from: 2,
          hideBtn: true
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },

    toggleSelection(row, column, cell, event) {

      //更新用户日志
      if (column.label == '备注') {
        let remarkForm = Object.assign({}, row);
        Dialog.open({
          title: '备注',
          component: StockRemarkDialog,
          data: {
            remarkForm: remarkForm,
            width: '500px'
          },
          close: () => {
            this.getPage()
          }
        })
      }
    },

    getSupplierList() {
      getFormData(listAllSupplier).then(data=> {
        this.supplierIdArray = [
          {name: '不限', id: 0}
        ]
        this.supplierIdArray = this.supplierIdArray.concat(data.data)
      })
    },

    getBrandList() {
      getFormData(listAllBrand).then(data=> {
        this.brandIdArray = [
          {name: '不限', id: 0}
        ]
        this.brandIdArray = this.brandIdArray.concat(data.data)
      })
    },

    getAllCommodityTypeList() {
      getFormData(listAllCommodityType).then(data=> {
        this.typeList = this.typeList.concat(data.data)
      })
    },


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    let ownShopList = JSON.parse(sessionStorage.getItem('ownShopList'))
    this.shopIdArray = this.shopIdArray.concat(ownShopList)
    this.shopId = this.shopIdArray[0].id
    this.getPage();
    this.getSupplierList()
    this.getBrandList()
    this.getAllCommodityTypeList()
  }
}
</script>

<style scoped>
/*.el-table {*/
/*  --el-table-header-bg-color: #ffffff !important;*/
/*}*/
.item-img {
  width: 80px;
  height: 80px;
}
</style>
